import React from 'react';
import './StyledButton.scss';
import {BsArrowRightShort} from 'react-icons/bs';
const StyledButton=(props)=>{
    return(
        <div  className={`primary-btn ${props.styles}`}> 
            <button>{props.btn} <BsArrowRightShort className="icon"/> </button>
        </div>
    )
};
export default StyledButton;